export default {
  setWorkerList(state, workerList) {
    state.workerList = workerList
  },
  setFilterCity(state, filterCity) {
    state.filterCity = filterCity
  },
  setFilterArea(state, filterArea) {
    state.filterArea = filterArea
  },
  setFilterLevel(state, filterLevel) {
    state.filterLevel = filterLevel
  },
  setFilterTime(state, filterTime) {
    state.filterTime = filterTime
  },
  setFilterService(state, filterService) {
    state.filterService = filterService
  },
  setStarLevelsList(state, starLevelsList) {
    state.starLevelsList = starLevelsList
  },
  setServiceTypeList(state, serviceTypeList) {
    state.serviceTypeList = serviceTypeList
  },
  setAreaList(state, areaList) {
    state.areaList = areaList
  },
  setAllWorkers(state, allWorkers) {
    state.allWorkers = allWorkers
  },
  setWorkerStars(state, list) {
    state.workerStars.push(...(list || []))
  },
  resetWorkerStars(state) {
    state.workerStars = []
  }
}
